const ButtonCode = ({ id }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  return (
    <div className='account-widget'>
      {/* Desktop version - visible on md screens and up - removed for now as ngrok url is too long */}
      <pre className='m-0 hidden' >
        <code>
          &lt;script{'\n'}
          {'    '}src="{apiBaseUrl}/button-loader.js"{'\n'}
          {'    '}id={id}{'\n'}
          async&gt;&lt;/script&gt;
        </code>
      </pre>
      
     
      {/* Medium mobile version (500px to md) - break at words */}
      <pre className='m-0 w-full max-w-full whitespace-normal break-all xl:break-normal'>
        <code>&lt;script src="{apiBaseUrl}/button-loader.js" id={id} async&gt;&lt;/script&gt;</code>
      </pre>
    </div>
  );
};

export default ButtonCode;
